export default __webpack_public_path__ + "static/media/CoolAC.b6852b0c.png";